import React, { useRef, useState, useContext, useEffect } from "react";
import Swal from "sweetalert2";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { ToWords } from "to-words";
import Templete from "../Templete/Templete";

import AuthService from "../../../services/Admin/AuthService";
import AdminCashDepositService from "../../../services/Admin/AdminCashDepositService";
import HttpError from "../../../utill/HttpError";
import LoadingContext from "../../../store/loading-context";

const EditCashDeposit = (props) => {
  const loadingCtx = useContext(LoadingContext);

  const [data, setData] = useState();

  const formRef = useRef();
  const amountRef = useRef();
  const paymentDateRef = useRef();
  const remarkRef = useRef();

  const editHandler = async () => {
    const amount = amountRef.current.value;
    const paymentDate = paymentDateRef.current.value;
    const remark = remarkRef.current.value;

    if (!amount) {
      Swal.fire("Opps!", "Invalid Amount", "error");
      return;
    }

    if (!paymentDate) {
      Swal.fire("Opps!", "Invalid Payment Date", "error");
      return;
    }

    if (!remark) {
      Swal.fire("Opps!", "Invalid Remark", "error");
      return;
    }

    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const id = props.id ? props.id : props.match.params.id;

      const responseData = await AdminCashDepositService.update(
        token,
        id,
        amount,
        paymentDate,
        remark
      );
      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        Swal.fire("Success!", message, "success");
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    loadingCtx.stopLoading();
  };

  useEffect(() => {
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    loadingCtx.startLoading();

    const id = props.id ? props.id : props.match.params.id;

    try {
      const token = AuthService.getAccessToken();

      const responseData = await AdminCashDepositService.fetchById(token, id);

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        setData(responseData.data);
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    loadingCtx.stopLoading();
  };

  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: true,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
      currencyOptions: {
        // can be used to override defaults for the selected locale
        name: "Rupee",
        plural: "Rupees",
        symbol: "₹",
        fractionalUnit: {
          name: "Paisa",
          plural: "Paise",
          symbol: "",
        },
      },
    },
  });

  const [amountInWord, setAmountInWord] = useState();

  const getWord = () => {
    const amount = amountRef.current.value;
    if (amount) {
      let words = toWords.convert(amount);
      setAmountInWord(words);
    } else {
      setAmountInWord();
    }
  };

  return (
    <React.Fragment>
      <Templete t1="Home" t2="Edit Cash Deposit">
        <section class="content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="card card-default">
                  <div class="card-header">
                    <h3 class="card-title">Edit Cash Deposit</h3>

                    <div class="card-tools">
                      <a
                        href="/admin/cash_deposit_history"
                        class="btn btn-block btn-outline-primary btn-sm"
                      >
                        Cash Deposit History
                      </a>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 mx-auto">
                      {data && (
                        <form ref={formRef} autoComplete="off">
                          <div class="card-body">
                            <div class="form-group row">
                              <label class="col-sm-2 col-form-label">
                                Amount
                              </label>
                              <div class="col-sm-10">
                                <input
                                  type="text"
                                  class="form-control form-control-lg"
                                  placeholder="Amount"
                                  maxLength={10}
                                  ref={amountRef}
                                  style={{ fontWeight: "bold" }}
                                  onChange={getWord}
                                  defaultValue={data ? data.amount : ""}
                                />
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    color: "red",
                                    fontSize: "16px",
                                  }}
                                >
                                  {amountInWord}
                                </p>
                              </div>
                            </div>

                            <div class="form-group row">
                              <label class="col-sm-2 col-form-label">
                                Payment Date
                              </label>
                              <div class="col-sm-10">
                                <input
                                  type="date"
                                  class="form-control"
                                  ref={paymentDateRef}
                                  defaultValue={data ? data.payment_date : ""}
                                />
                              </div>
                            </div>

                            <div class="form-group row">
                              <label class="col-sm-2 col-form-label">
                                Remark
                              </label>
                              <div class="col-sm-10">
                                <textarea
                                  class="form-control"
                                  ref={remarkRef}
                                  defaultValue={data ? data.remark : ""}
                                ></textarea>
                              </div>
                            </div>

                            <div class="card-footer text-center">
                              <button
                                type="button"
                                class="btn btn-primary"
                                onClick={editHandler}
                              >
                                Submit
                              </button>
                              <button type="reset" class="btn btn-default ml-5">
                                Reset
                              </button>
                            </div>
                          </div>
                        </form>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Templete>
    </React.Fragment>
  );
};

export default EditCashDeposit;
